export default __webpack_public_path__ + "static/media/incbystate_00_20.b5afb9e9.csv";